import {clone} from '@/app-core/lib/utils/helper'
import Translatable from '@/app-core/mixins/translatable'
import ProductPrice from '@/app-theme/components/product/ProductPrice.vue'
import ProductQuantity from '@/app-theme/components/product/ProductQuantity.vue'
import ProductListCommon from '@/app-core/mixins/product/productListCommon'
import ProductTags from '@/app-theme/components/product/ProductTags.vue'
import productTags from '@/app-theme/components/product/ProductTags.vue'
import ProductCartQuantitySelector from '@/app-theme/components/product/ProductCartQuantitySelector.vue'
import ProductQuantityCommon from '@/app-core/mixins/product/productQuantityCommon'

export default {
  name      : 'CartProductListItem',
  components: {
    ProductCartQuantitySelector,
    ProductTags,
    ProductQuantity,
    ProductPrice
  },
  directives: {},
  mixins    : [Translatable, ProductListCommon, ProductQuantityCommon],
  props     : {
    product: {
      type   : Object,
      default: undefined
    },

    showProductQuantity: {
      type   : Boolean,
      default: false
    },

    showProductTags: {
      type   : Boolean,
      default: false
    },

    storeLogo: {
      type   : Boolean,
      default: false
    },

    disabled: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {},
  data() {
    return {}
  },
  computed: {
    productTags() {
      return productTags
    },
    selectedProduct() {
      return this.product
    },

    productDisabled() {
      return !this.product || this.disabled || this.productLoading
    },

    productLoading() {
      return this.product?.LoadingShow || this.product?.LoadingRemove || this.product?.LoadingUpdate
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onProductClick(product) {
      if (this.productDisabled) return
      const item = clone(product)

      this.$bus.$emit('product:details-dialog', item)
    }
  }
}
